import { AfterContentInit, Component, ContentChildren, HostBinding, Input, QueryList } from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";
import { onNextTick } from "@spscommerce/utils";

import {
    SpsDescriptionListDefinitionComponent,
} from "../description-list-definition/sps-description-list-definition.component";
import { SpsDescriptionListTermComponent } from "../description-list-term/sps-description-list-term.component";

@Component({
    selector: "sps-description-list, sps-dl",
    templateUrl: "./sps-description-list.component.html"
})
export class SpsDescriptionListComponent implements AfterContentInit {
    static readonly displayName = "sps-description-list / sps-dl";
    static readonly props = {
        compact: "boolean",
        wideTerms: "boolean",
        widerTerms: "boolean",
    };

    @HostBinding("class.sps-description-list") readonly _spsDescriptionListClass = true;

    @HostBinding("class.sps-description-list--compact")
    @Input()
    @AttributePresenceInput()
    compact;

    @HostBinding("class.sps-description-list--wide-terms")
    @Input()
    @AttributePresenceInput()
    wideTerms;

    @HostBinding("class.sps-description-list--wider-terms")
    @Input()
    @AttributePresenceInput()
    widerTerms;

    @ContentChildren(SpsDescriptionListTermComponent) _terms: QueryList<SpsDescriptionListTermComponent>;
    @ContentChildren(SpsDescriptionListDefinitionComponent)
    _definitions: QueryList<SpsDescriptionListDefinitionComponent>;

    ngAfterContentInit() {
        onNextTick(() => {
            this._terms.forEach((termComponent, i) => {
                termComponent.rowIndex = i + 1;
            });

            this._definitions.forEach((definitionComponent, i) => {
                definitionComponent.rowIndex = i + 1;
            });
        });
    }
}
